export const fmt = {
    text: (t) => (t && String(t).trim().length ? t : "—"),
    personName: (p) =>
        [p?.nombre, p?.apellidos].filter(Boolean).join(" ") ||
        p?.nickname ||
        `Persona #${p?.id}`,
};
